import labels from './labels/list/reducers'
import createLabel from './labels/create/reducers'
import destroyLabel from './labels/destroy/reducers'
import updateLabel from './labels/update/reducers'
import detailLabel from './labels/details/reducers'

import createAccount from './account/create/reducers'
import accountDetails from './account/details/reducers'
import updateAccount from './account/update/reducers'

import rules from './rules/list/reducers'
import createRule from './rules/create/reducers'
import destroyRule from './rules/destroy/reducers'
import updateRule from './rules/update/reducers'
import detailRule from './rules/details/reducers'

export default {
  labels,
  createLabel,
  destroyLabel,
  updateLabel,
  detailLabel,
  createAccount,
  accountDetails,
  updateAccount,
  rules,
  createRule,
  destroyRule,
  updateRule,
  detailRule,
}
